/** Besatzungs-/Fahrzeug-Board — BOS-Sprache (nicht HR-Jargon) */
export const CREW_ROLE_DE: Record<string, string> = {
  firefighter: "Einsatzkraft",
  officer: "Polizeibeamter",
  medic: "Rettungskraft",
  dispatcher: "Disponent",
  group_leader: "Gruppenführer",
  apparatus_driver: "Maschinist",
  boat_crew: "Bootsführer",
  thw_helper: "THW-Helfer",
  mechanic: "Mechaniker",
  instructor: "Ausbilder",
};

/** Bewerbung / Werbung — HR-Begriffe erlaubt */
export const RECRUIT_ROLE_DE: Record<string, string> = {
  ...CREW_ROLE_DE,
  firefighter: "Feuerwehrmann/frau",
};

/** Personnel status — one vocabulary everywhere (Belegschaft + Besatzung) */
export const PERSON_STATUS_DE: Record<string, string> = {
  idle: "Verfügbar",
  assigned: "Gebunden",
  off_duty: "Außer Dienst",
  training: "Lehrgang",
  sick: "Krank",
};

export function roleLabel(role: string, context: "crew" | "recruit" = "crew"): string {
  const map = context === "recruit" ? RECRUIT_ROLE_DE : CREW_ROLE_DE;
  return map[role] ?? role;
}

export function statusLabel(status: string): string {
  return PERSON_STATUS_DE[status] ?? status;
}

export const STATION_KINDS = [
  "fire_station",
  "police_station",
  "ems_station",
  "thw",
  "leitstelle",
  "workshop",
  "school",
] as const;

export type ApplicantRecruitStatus = "applied" | "interviewing" | "interview_done";

export const APPLICANT_STATUS_DE: Record<ApplicantRecruitStatus, string> = {
  applied: "Neue Bewerbung",
  interviewing: "Gespräch läuft",
  interview_done: "Gespräch abgeschlossen",
};

export const INTERVIEW_QUALITY_DE: Record<string, string> = {
  good: "Guter Eindruck",
  fair: "Solider Eindruck",
  poor: "Schwacher Eindruck",
};

/** Dauer Bewerbungsgespräch (~1 Min, wie API recruitFlow.ts) */
export const RECRUIT_INTERVIEW_MS = 60_000;

/** Typische Verzögerung bis erste Bewerber eintreffen (Werbung ohne hr_recruit_phases) */
export const RECRUIT_APPLICANT_STAGGER_MS = 55_000;

/** Grobe Könnens-Schätzung vor dem Gespräch */
export function applicantSkillPreview(skill: number): { min: number; max: number } {
  const spread = 12;
  return {
    min: Math.max(15, skill - spread),
    max: Math.min(92, skill + spread),
  };
}
